<template>

  <div>

    <loading v-show="showLoading"></loading>

    <div class="home_content" v-show="!showLoading">
      <!--首页搜索-->
      <div class="nav_bar" style="border-bottom: 0px;">
        <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>

        <div class="search_bar clear_both" style="z-index: 101;background-color: white;width:17.8rem;display: inline-block;vertical-align: top;position: relative;top: -0.5rem;">
          <div class="fl" style="background-color: white" ref="search0" role="button" index="0" :status="search0_status" @click="changeSearchBarStyle(0,search0_status)">
            <span>综合</span>
          </div>
          <div class="fl" style="background-color: white" ref="search1" role="button" index="1" :status="search1_status" @click="changeSearchBarStyle(1,search1_status)"><span>销量</span></div>
          <div class="fl" style="background-color: white" ref="search2" role="button" index="2" :status="search2_status" @click="changeSearchBarStyle(2,search2_status)">
            <span>价格</span>
            <img ref="jiage" class="search_bar_icon" src="@/images/icon_jiage@3x.png">
          </div>

        </div>


        <button class="clear_style nav_bar_right_item" style="width: 2rem;height: 2rem;display: inline-block;vertical-align: top;" @click="changeLayout"><img class="nav_item_btn" :src="layout==true?list1_icon:list2_icon"></button>

      </div>

      <!--productList-->
      <div class="content_list clear_both">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div>
            <div v-for="(productItem,index) in productList" :key="index" :class="[layout==true?'pl_info1 fl':'pl_info2']">
              <router-link :to="{name:'goodsDetail',query:{goodsId:productItem.productId,}}">
                <van-image :class="[layout==true?'pl_info1_img':'pl_info2_img']" fit="cover" :src="productItem.imgSrc"/>
                <p @click="pushDetailView(productItem.productId)" :class="[layout==true?'pl_info1_title':'pl_info2_title']">{{productItem.productName}}</p>
                <span  :class="[layout==true?'pl_info1_price fl':'pl_info2_price fl']">¥{{productItem.price.toFixed(2)}}</span>
                <span :class="[layout==true?'pl_info1_addCart fr':'pl_info2_addCart fr']">{{productItem.quantity}}人付款</span>
              </router-link>
            </div>

            <div class="cart_content" v-if="emptyList">
              <p class="tc grey zt14" style="padding: 2rem 0">暂无可售商品信息</p>
            </div>

            <refresh class="fl full_w" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: productList.length,show:show}'></refresh>
          </div>
        </van-pull-refresh>
      </div>
    </div>


    <transition name="router-slid" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>

</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getProductCategory,getProductList,login,getActivityProduct ,getWeixinShare} from '@/router/api';
  import { NavBar,Image,Tabbar,DropdownMenu,DropdownItem,SwitchCell,Button } from 'vant';
  import { Search,Overlay,List,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: "activityList",

    components: {
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [Search.name]: Search,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [SwitchCell.name]: SwitchCell,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh
    },

    data() {
      return {
        searchValue:"",
        isLoading:false,
        showLoading:true,

        search0_status: 0,  //点击第1个筛选项的状态
        search1_status: 0,  //点击第2个筛选项的状态
        search2_status: 0,  //点击第3个筛选项的状态

        list1_icon:require('@/images/icon_columnlist@3x.png'),    //大图模式图标
        list2_icon:require('@/images/icon_rowlist@3x.png'),    //列表模式图标

        layout:true,        //切换模式


        productList:[],

        listSize:0,

        token:"",


        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        // topCategoryId:10170,
        // 正式
        topCategoryId:10140,
        orderBy:0,
        sortDirc:'',
        viewIndex:0,  //default 0
        viewSize:20,

        emptyList:false,

        show: false,
        allLoaded: false
      }
    },

    methods: {

      async initData() {
        this.getProductList();
        this.setParams()
      },

      setParams:function(){
        let param;
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          //这个是安卓操作系统
          param = 'android'
        }
        if (isIOS) {
          //这个是ios操作系统
          param = 'ios'
        }
        let paramList = {
          url: window.location.href,
          os:param
        }
        getWeixinShare(paramList).then(res => {
          console.log(res)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.shareMap.appId, // 必填，公众号的唯一标识
            timestamp: res.shareMap.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.shareMap.nonceStr, // 必填，生成签名的随机串
            signature: res.shareMap.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
          });

          var thisBlock = this
          wx.ready(function(){
            wx.updateAppMessageShareData({
              title: '女神节专属礼遇', // 分享标题
              desc: '乐园女神节专属礼遇，只属于你！', // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              // link:'https://testdms.hellokittypark.cn/catalog/control/main#11111',
              imgUrl: 'http://5b0988e595225.cdn.sohucs.com/images/20181210/7d82911fcf59423ca454b7074b89025e.jpeg', // 分享图标
              success: function () {
              },error:function () {
              }
            })

            //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: '女神节专属礼遇',
              desc: '乐园女神节专属礼遇，只属于你！',
              link: window.location.href,
              // link:'https://testdms.hellokittypark.cn/catalog/control/main#11111',
              imgUrl: 'http://5b0988e595225.cdn.sohucs.com/images/20181210/7d82911fcf59423ca454b7074b89025e.jpeg',
              success: function () {
              },error:function () {
              }
            })
          });

        })
      },

      getProductList() {

        var param = {
          productStoreId:this.productStoreId,
          prodCatalogId:this.prodCatalogId,
          topCategoryId:this.topCategoryId,
          orderBy:this.orderBy,
          sortDirc:this.sortDirc,
          viewIndex:this.viewIndex,
          viewSize:this.viewSize
        }

        getActivityProduct(param)
          .then(res => {
            console.log(res);
            if (res.productList) {
              if (res.productList.length == 0){
                this.emptyList = true
              } else {
                this.emptyList = false
              }

              this.productList = res.productList;

              this.viewIndex = res.VIEW_INDEX;
              this.viewSize = res.VIEW_SIZE;

              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
              this.show = false
            } else {
              Toast("未搜索到您想要的宝贝");
            }
          })
          .catch(err => {
            console.log(err);
          });
      },


      //切换搜索状态
      //当前状态只用于展示哪个按钮被点击
      changeSearchBarStyle (index,status) {
        this.clearStyle();
        this.closeAll();
        this.productList = []
        switch (index) {
          case 0:
            // 综合
            this.orderBy = 0
            if (status == 0) {
              this.$refs.search0.style.color = "#666666";
              this.search0_status = 1;
              this.viewIndex = 0
              this.sortDirc = '+'
              this.getProductList();
            } else if (status == 1) {
              this.$refs.search0.style.color = "#999999";
              this.search1_status = 0;
              this.viewIndex = 0
              this.sortDirc = '-'
              this.getProductList();
            }
            break;
          case 1:
            // 销量
            this.orderBy = 2
            if (status == 0) {
              this.$refs.search1.style.color = "#666666";
              this.search1_status = 1;
              this.viewIndex = 0
              this.sortDirc = '+'
              this.getProductList();
            } else if (status == 1) {
              this.$refs.search1.style.color = "#999999";
              this.search1_status = 0;
              this.viewIndex = 0
              this.sortDirc = '-'
              this.getProductList();
            }
            break;
          case 2:
            // 价格
            this.orderBy = 1
            if (status == 0) {
              this.$refs.search2.style.color = "#666666";
              this.$refs.jiage.src = require('@/images/icon_jiage_up@3x.png');
              this.search2_status = 1;
              this.viewIndex = 0
              this.sortDirc = '+'
              this.getProductList();
            } else if (status == 1) {
              this.$refs.search2.style.color = "#666666";
              this.$refs.jiage.src = require('@/images/icon_jiage_down@3x.png');
              this.search2_status = 2;
              this.viewIndex = 0
              this.sortDirc = '-'
              this.getProductList();
            } else if (status == 2) {
              this.$refs.search2.style.color = "#666666";
              this.$refs.jiage.src = require('@/images/icon_jiage_up@3x.png');
              this.search2_status = 1;
              this.viewIndex = 0
              this.sortDirc = '+'
              this.getProductList();
            }
            break;
          default:
            break;
        }
      },

      // 清除搜索样式
      clearStyle () {
        this.search0_status = 0;
        this.$refs.search0.style.color = "#999999";
        this.search1_status = 0;
        this.$refs.search1.style.color = "#999999";
        this.search2_status = 0;
        this.$refs.search2.style.color = "#999999";
        this.$refs.jiage.src = require('@/images/icon_jiage@3x.png');
      },

      // 切换列表还是大图
      changeLayout () {
        this.layout = !this.layout
        console.log(this.layout)
      },


      //收起all
      closeAll () {
        this.clearStyle();
      },


      //跳转详情页
      pushDetailView (item){
        this.$router.push({path:'/productList', query:{keyWord:item.keyword}});
      },

      //下拉刷新
      onRefresh() {
        // if (this.allLoaded != true) {
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        // }
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;

          var param = {
            productStoreId:this.productStoreId,
            prodCatalogId:this.prodCatalogId,
            topCategoryId:this.topCategoryId,
            orderBy:this.orderBy,
            sortDirc:this.sortDirc,
            viewIndex:this.viewIndex,
            viewSize:this.viewSize
          }

          getActivityProduct(param)
            .then(res => {
              console.log(res);
              if (res.productList) {
                this.show = true
                if (res.productList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.productList
                var newProductList = oldProductList.concat(res.productList)
                this.productList = newProductList
                this.viewIndex = res.viewIndex;
              } else {
                Toast("未搜索到您想要的宝贝");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
    },

    mounted() {
      this.initData();
    },

  }
</script>

<style>

  .content_container {
    padding: 0 1rem
  }

  .search_bar {

  }

  .search_bar div {
    text-align: center;
    font-size: 0.875rem;
    color: #999999;
    width: 5.8rem;
    line-height: 3rem;
  }

  .search_bar_icon {
    position: absolute;
    width: 1.125rem;height: 1.125rem;
    margin: 0.9rem 0 0 0.2rem;
  }

  .content_list {
    padding-bottom: 0rem;
    padding-top: 3.5rem;
  }

  .pl_title {
    padding-left: 1rem;font-weight: bold;border-left-width: 0.1rem;border-left-style: solid;border-left-color: #EB84AB
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.875rem;color: #333333;margin-bottom: 0.5rem;height: 2.2rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .pl_info2 {
    height: 5rem;padding: 0.8rem 1rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info2_img {
    width: 5rem;height: 5rem;float: left;margin-right: 0.5rem;line-height: 6.875rem;
  }

  .pl_info2_title {
    float: left;width: 15rem;height:3rem;margin: 0;font-size: 0.875rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info2_price {
    font-size: 1rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info2_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .tag_list > li {
    line-height: 2rem;
    margin: 0 0.6rem 0.6rem 0;
  }

  .tag_item {
    background-color: #f5f5f5;padding: 0.5rem 1rem;border-radius: 0.3rem;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.5rem;margin: 0 0.4rem;background-color: #f5f5f5;height: 2rem;line-height: 2rem;padding: 0 0.8rem;border-radius: 1rem
  }

  .nav_bar_search > img {
    width: 0.8rem;height: 0.8rem;margin-right: 0.5rem;
  }

  .nav_bar_search > span {
    font-size: 0.75rem;color: #999999;
  }

  .nav_bar_right_item {
    padding-top: 0.3rem;
  }

  .animate_action {
    transition: all .4s;
  }


  .reset_btn {
    padding: 0.3rem 0;
    width: 6.25rem;
    border-radius: 0.5rem;
    background-color: #F5F5F5;
    color: #333333;
  }

  .done_btn {
    padding: 0.3rem 0;
    margin-left: 2rem;
    width: 6.25rem;
    background-color: #EB84AB;
    color: white;
    border-radius: 0.5rem;
  }

  .open_btn {
    width: 1.25rem;
    height: 1.25rem;
  }

  .close_ul {
    height: 0px;
  }

  .cell_title {
    clear: both;
    overflow: hidden;
    width: 21.43rem;
  }

  .cell_title span {
    font-size: 0.875rem;
  }

  .input_view {
    width: 5rem;
    background-color: #f5f5f5;
    border-style: none;
  }

  /*input*/
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }
  input:-moz-placeholder, textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }
  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }

  .element::-webkit-scrollbar { width: 0 !important }

  .element { -ms-overflow-style: none; }

  .element { overflow: -moz-scrollbars-none; }

</style>



// WEBPACK FOOTER //
// src/components/page/activity/activityList.vue